export class ObsQuestionResponse {
    id: number;
    obsCategoryId: number;
    obsCategoryDescription: string;
    obsQuestionDescription: string;
    responseTypeId: number;
    response: any;
}